'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rebass = require('rebass');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var Contributor = function Contributor(_ref) {
  var avatar = _ref.avatar,
      fullName = _ref.fullName,
      title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['avatar', 'fullName', 'title', 'children']);

  return _react2.default.createElement(_rebass.Flex, _extends({
    flexDirection: 'column',
    alignItems: 'center'
  }, props), _react2.default.createElement(_rebass.Avatar, {
    src: avatar,
    size: 128,
    alt: ''
  }), _react2.default.createElement(_rebass.Lead, {
    textAlign: 'center',
    m: 3
  }, fullName), _react2.default.createElement(_rebass.Text, {
    textAlign: 'center',
    mb: 3,
    style: {
      opacity: 3 / 4
    }
  }, title), children);
};

Contributor.propTypes = {
  avatar: _propTypes2.default.string,
  fullName: _propTypes2.default.string,
  title: _propTypes2.default.string,
  children: _propTypes2.default.any
};
exports.default = Contributor;